"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var ServicesTableRow_1 = __importDefault(require("containers/MyStack/styles/ServicesTableRow"));
var ServiceDetails_1 = __importDefault(require("./ServiceDetails"));
var ServicesListRow = function (_a) {
    var item = _a.item, team = _a.team;
    return (
    // undefined means noneSelected, the 3 options undefined, true and false all have different styles
    // ToDo: check `cursor="default" pr={24} mr={-32}` here
    // <ServicesTableRow cursor="default" pr={24} mr={-32}>
    (0, jsx_runtime_1.jsx)(ServicesTableRow_1.default, { children: (0, jsx_runtime_1.jsx)(ServiceDetails_1.default, { item: item, team: team }) }));
};
exports.default = react_1.default.memo(ServicesListRow);
